export const DOCUMENT_TYPES_CACHE_KEY = "cache:document-types";
